export enum JobStatus {
  UPLOAD = 'Upload',
  COMPLETED = 'Completed',
  ERROR = 'Error',
}

export interface JobInfo {
  status: JobStatus;
  error: string | null;
}
